import React, { Fragment, useState, useEffect } from 'react';
import ProductTypeResult from '../Search/ResultTypes/ProductTypeResult';
import {
    filterGEOProductSKUs,
    ga4TrackingEcommerce
} from '../../tools/utilities';

const RelatedProduct = ({
    results,
    country,
    currency,
    userGeoData
}) => {
    const [sendViewItem, setSendViewItem] = useState(true);

    useEffect(() => {
        if (sendViewItem && results.length > 0 && results !== null) {
            const items = results
                .map(result => {
                    let selectedSku = null;
                    const skus = filterGEOProductSKUs(result._source.skus, currency, country);
                    if (skus.length > 0) {
                        const firstKey = Object.keys(skus)[0];
                        selectedSku = skus[firstKey];
                    }

                    return selectedSku;
                })
                .filter(result => result !== null);
            if (items.length > 0) {
                ga4TrackingEcommerce('view_item', items);
                setSendViewItem(false);
            }
        }
    }, [sendViewItem, results]);

    const relatedProduct = results.map((item) => {
        return (
            <Fragment key={item._source.id}>
                <ProductTypeResult
                    item={item._source}
                    country={country}
                    currency={currency}
                    userGeoData={userGeoData}
                />
            </Fragment>
        );
    });

    return relatedProduct;
}

export default RelatedProduct;
